import { useEffect, useState } from "react";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  const [jump, setJump] = useState("");

  useEffect(() => {
    setJump("");
  }, [currentPage]);

  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  const go = (page: number) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) onChange(page);
  };

  const handleJump = () => {
    const num = Number(jump);
    if (!Number.isNaN(num)) go(num);
  };

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2 mt-8" aria-label="分页导航">
      <button
        type="button"
        onClick={() => go(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3.5 py-2 rounded-md border border-background-200 text-sm text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line mr-1" />
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => go(page)}
          className={`w-9 h-9 rounded-md text-sm font-medium transition-colors cursor-pointer ${
            page === currentPage
              ? "bg-primary-500 text-background-50"
              : "border border-background-200 text-foreground-700 hover:bg-background-100"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => go(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3.5 py-2 rounded-md border border-background-200 text-sm text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line ml-1" />
      </button>

      <div className="flex items-center gap-1.5 ml-1 text-sm text-foreground-500">
        <span>跳至</span>
        <input
          value={jump}
          onChange={(e) => setJump(e.target.value.replace(/[^0-9]/g, ""))}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleJump();
          }}
          inputMode="numeric"
          className="w-12 h-9 text-center rounded-md border border-background-200 bg-background-50 text-foreground-900 text-sm outline-none focus:border-primary-400"
          aria-label="跳转到页码"
        />
        <span>页</span>
        <button
          type="button"
          onClick={handleJump}
          className="px-3 h-9 rounded-md bg-secondary-500 hover:bg-secondary-600 text-background-50 text-sm transition-colors cursor-pointer whitespace-nowrap"
        >
          跳转
        </button>
      </div>
    </nav>
  );
}